//@flow
import React from "react"
import { connect } from "react-redux"
import { replace, push } from "react-router-redux"
import { compose } from "react-apollo"
import { Helmet } from "react-helmet"
import styled from "styled-components"
import {
  EntityDetail,
  CenteredEntityDetail,
  EntityAction,
  EntityPrimaryLink
} from "../UI/EntityList"
import { GridView } from "../UI/GridView"
import Loader from "../UI/Loader"
import { Icon } from "../UI/Sidebar"
import { parseQueryString } from "../RoutingHelpers"
import queries from "./queries"
import type { SlideListViewProps } from "./types"
import { confirmDeletePath } from "./helpers"

const SlideIcon = Icon.extend`
  text-align: center;
  width: 100%;
  font-size: 4rem;
`

const EntitySlide = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
`
type State = { mutationLoading: boolean }
class SlideListView extends React.Component<SlideListViewProps, State> {
  constructor(props) {
    super(props)
    this.state = { mutationLoading: false }
  }

  handleNewPositions = positions => {
    const { attractLoopId, reorderSlides } = this.props
    const positionInput = {
      positions
    }
    reorderSlides(attractLoopId, positionInput)
  }

  render() {
    const {
      slides,
      loading,
      match,
      attractLoopId,
      history: { push }
    } = this.props
    const count = slides ? slides.length : 0
    return (
      <Loader loading={loading}>
        <Helmet>
          <title>{`${count} Slide${count === 1 ? "" : "s"}`}</title>
        </Helmet>
        <GridView
          itemWidth={200}
          itemHeight={200}
          staticChildCount={1}
          gutter={10}
          onRepositioned={this.handleNewPositions}
        >
          {slides &&
            Array.from(slides)
              .sort((a, b) => a.position - b.position)
              .map(slide => (
                <EntitySlide key={slide.id}>
                  <EntityDetail grow={0}>
                    <EntityPrimaryLink to={`${match.url}/${slide.id || ""}`}>
                      {slide.title}
                    </EntityPrimaryLink>
                  </EntityDetail>
                  <EntityDetail grow={1}>
                    <img
                      src={slide.mediaURL}
                      alt={`Media for ${slide.title}`}
                      style={{
                        display: "block",
                        maxWidth: "100%",
                        pointerEvents: "none"
                      }}
                    />
                  </EntityDetail>
                  <EntityDetail grow={0} shrink={0} row end>
                    <EntityAction
                      href="#"
                      onClick={() => push(`${match.url}/${slide.id || ""}`)}
                      icon="✏️"
                    />
                    <EntityAction
                      href="#"
                      onClick={() =>
                        push(
                          confirmDeletePath(
                            match.url,
                            attractLoopId,
                            slide.id || ""
                          )
                        )}
                      icon="❌"
                    />
                  </EntityDetail>
                </EntitySlide>
              ))}
          <EntitySlide onClick={() => push(`${match.url}/new`)} key="new.slide">
            <EntityDetail grow={0}>
              <EntityPrimaryLink to={`${match.url}/new`}>
                New Slide
              </EntityPrimaryLink>
            </EntityDetail>
            <CenteredEntityDetail grow={1}>
              <SlideIcon>🖼</SlideIcon>
            </CenteredEntityDetail>
          </EntitySlide>
        </GridView>
      </Loader>
    )
  }
}

const SlidesWithData = compose(queries.withSlides, queries.mutateReorderSlides)(
  SlideListView
)

export default connect(
  state => ({
    searchName: parseQueryString(state, "name")
  }),
  {
    replace,
    push
  }
)(SlidesWithData)



// WEBPACK FOOTER //
// ./src/Slides/SlideListView.js